import type { UnwrapRef } from 'vue';
import type { Call } from '@/stores/useCallStore';
import { initSpokes } from '@/libraries/headset/spokes';
import { isWindows } from '@/utils/clientUtils';

export interface Headset {
  isConnected: () => boolean;
  connect: () => void;
  disconnect: () => void;
  incomingCall: (call: UnwrapRef<Call>) => void;
  answerCall: (callUuid: string) => void;
  endCall: (callUuid: string) => void;
  muteCall: (mute: boolean) => void;
}

export let headsetService: Headset | undefined;

//todo probably can be removed verify after adding new service
const emptyHeadsetService: Headset = {
  isConnected: () => false,
  connect: () => {},
  disconnect: () => {},
  incomingCall: (call: UnwrapRef<Call>) => {},
  answerCall: (callUuid: string) => {},
  endCall: (callUuid: string) => {},
  muteCall: (mute: boolean) => {},
};

const isSupportedPolyHeadset = (audioLabels: string[]) => isWindows() && audioLabels.find((audioLabel) => audioLabel.includes('Poly'));

const headsetBuilder = async (audioLabels: string[]): Promise<Headset | undefined> => {
  if (isSupportedPolyHeadset(audioLabels)) {
    return await initSpokes();
  }
};

export const initHeadset = async (audioLabels: string[]) => {
  if (headsetService?.isConnected()) headsetService?.disconnect();
  headsetService = (await headsetBuilder(audioLabels)) || emptyHeadsetService;
  headsetService?.connect();
};

export const disconnectHeadset = () => {
  headsetService?.disconnect();
};
